import { FORM_ERR_MESSAGE } from 'app/utils/constants/validation';
import * as Yup from 'yup';

const schemaLogin = Yup.object().shape({
  username: Yup.string()
    .email('Masukkan alamat email yang valid.')
    .required('Email harus diisi')
    .max(234, 'Email tidak boleh lebih dari 234 karakter.'),
  password: Yup.string()
    .required(`Password ${FORM_ERR_MESSAGE.REQUIRED}`)
    .min(8, `Password minimal 8 karakter.`)
    .max(30, `Password maksimal 30 karakter.`)
    .matches(/^[^\s]{8,30}$/, "Password tidak boleh mengandung spasi"),
});

export const initialValues = {
  username: '',
  password: ''
}
export default schemaLogin;